import { useState } from "react";
import { Box } from "@mui/material";
import {
  ExpandMoreRounded as ExpandMoreRoundedIcon,
  ExpandLessRounded as ExpandLessRoundedIcon,
} from "@mui/icons-material";
import { BarItem } from "./HeaderBars";
import { UserMenuProps } from "./types";
import { DropDownMenu } from "../DropDownMenu";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import React from "react";

export const UserMenu: React.FC<UserMenuProps> = ({
  username,
  dropDownOptions,
  customOptions,
  helpText,
  helpLink,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const modecLink =
    "https://shapedigital.atlassian.net/servicedesk/customer/portal/36";

  if (!username) return null;

  return (
    <BarItem>
      {helpText && (
        <Box
          component="div"
          sx={{
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            fontSize: 12,
            color: "#666666",
          }}
        >
          <a
            href={helpLink || modecLink}
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#666666",
              fontSize: 12,
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              display: "flex",
              alignItems: "center",
            }}
          >
            <HelpOutlineIcon sx={{ fontSize: 16, paddingRight: 0.5 }} />

            {helpText}
          </a>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          position: "relative",
          cursor: "pointer",
          ".MuiSvgIcon-root": {
            fontSize: "24px",
          },
        }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <Box
          component="span"
          mr={1}
          sx={{
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            fontSize: 12,
            color: "#666666",
            paddingLeft: 3,
          }}
        >
          {username}
        </Box>
        {dropDownOptions && (
          <>
            {isOpen ? (
              <ExpandLessRoundedIcon sx={{ fill: "#666666" }} />
            ) : (
              <ExpandMoreRoundedIcon sx={{ fill: "#666666" }} />
            )}
            {isOpen && (
              <DropDownMenu
                dropDownOptions={dropDownOptions}
                customOptions={customOptions}
                onClickAway={() => setIsOpen(false)}
              />
            )}
          </>
        )}
      </Box>
    </BarItem>
  );
};
